import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
	iconStyles: {
		padding: '0px',
		marginLeft: '7px',
		marginBottom: '2px',
		borderRadius: '50%'
	}
}));
